/* RSL Rental Phase 1 core — 2026-07-12 */
(() => {
  'use strict';
  if (window.RSLRentalCore) return;

  const KEYS = Object.freeze({
    items: 'rsl_rental_quote_items_v1',
    settings: 'rsl_rental_quote_settings_v1'
  });

  const safeRead = (key, fallback) => {
    try {
      const value = JSON.parse(window.localStorage.getItem(key) || 'null');
      return value ?? fallback;
    } catch (_) {
      return fallback;
    }
  };

  const safeWrite = (key, value) => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (_) {
      return false;
    }
  };

  const normalizeDateRange = (start, end) => {
    const from = /^\d{4}-\d{2}-\d{2}$/.test(start || '') ? start : '';
    let to = /^\d{4}-\d{2}-\d{2}$/.test(end || '') ? end : '';
    if (from && !to) to = from;
    if (from && to && to < from) to = from;
    return { start: from, end: to };
  };

  const rentalDays = (start, end) => {
    const range = normalizeDateRange(start, end);
    if (!range.start || !range.end) return 1;
    const from = new Date(`${range.start}T12:00:00`);
    const to = new Date(`${range.end}T12:00:00`);
    return Math.max(1, Math.round((to - from) / 86400000) + 1);
  };

  const dispatch = (name, detail = {}) => {
    document.dispatchEvent(new CustomEvent(`rsl:rental:${name}`, { detail }));
  };

  const getSettings = () => {
    const stored = safeRead(KEYS.settings, {});
    return { ...stored, ...normalizeDateRange(stored.start, stored.end) };
  };

  const setPeriod = (start, end, source = 'core') => {
    const current = getSettings();
    const range = normalizeDateRange(start, end);
    const next = { ...current, ...range, updatedAt: new Date().toISOString() };
    safeWrite(KEYS.settings, next);
    dispatch('period-change', { ...range, days: rentalDays(range.start, range.end), source });
    return next;
  };

  const getItems = () => {
    const items = safeRead(KEYS.items, []);
    return Array.isArray(items) ? items : [];
  };

  const syncPeriodFields = () => {
    const settings = getSettings();
    document.querySelectorAll('[data-rslr-date-start], [data-guide-start]').forEach((field) => {
      if (settings.start && !field.value) field.value = settings.start;
    });
    document.querySelectorAll('[data-rslr-date-end], [data-guide-end]').forEach((field) => {
      if (settings.end && !field.value) field.value = settings.end;
    });
  };

  const bindPeriodFields = () => {
    document.addEventListener('change', (event) => {
      const field = event.target;
      if (!(field instanceof HTMLInputElement)) return;
      if (!field.matches('[data-rslr-date-start], [data-rslr-date-end], [data-guide-start], [data-guide-end]')) return;
      const root = field.closest('[data-rslr-quote-app], [data-guide], form, section') || document;
      const start = root.querySelector('[data-rslr-date-start], [data-guide-start]')?.value || getSettings().start;
      const end = root.querySelector('[data-rslr-date-end], [data-guide-end]')?.value || start;
      setPeriod(start, end, 'field');
    });
  };

  const stabilizeHeader = () => {
    const header = document.querySelector('[data-rslr-header]');
    if (!header) return;
    document.documentElement.classList.add('rslr-phase1-ready');
    header.classList.add('rslr-header--stable');
  };

  window.RSLRentalCore = Object.freeze({
    version: '1.0.0-phase1',
    keys: KEYS,
    getItems,
    getSettings,
    setPeriod,
    rentalDays,
    dispatch
  });

  const start = () => {
    stabilizeHeader();
    syncPeriodFields();
    bindPeriodFields();
    dispatch('core-ready', { version: window.RSLRentalCore.version });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
